import * as React from 'react'
import {
  PublicFooterInfoColumn,
  PublicFooterContainer,
  PublicFooterLink,
  PublicFooterRegularText,
  PublicFooterRow,
  PublicFooterSpaceBetween,
  PublicFooterSubtitle,
  PublicFooterTitle,
  PublicFooterCopyrightColumn,
  PublicFooterSmallLetterColumn,
  PublicFooterCopyrightContainer,
  PublicFooterSmallText,
  PublicFooterSmallTextMarginBottom, PublicFooterLinkNoMarginTop, PublicFooterEmptyColumn, PhoneNumberWrapper,
  PublicFooterEmptyColumnRight
} from './PublicFooter.elements'
import { PhoneNumber } from '@components/PhoneNumber'
import {MouseEvent} from "react"
import {getPhoneNumber} from "@lib/PhoneNumber"
import Analytics from "@lib/Analytics"
import Pixels from '@lib/Pixels'

type Props = {
  healthIqSection: HealthIqSection[];
  products: ColumnSection[];
  about: ColumnSection[];
  legal: ColumnSection[];
  company: string[];
  disclaimers: string[];
  phoneMapping: PhoneMapping;
}

export type HealthIqSection = {
  text?: string;
  isTitle?: boolean;
  isPhoneNumber?: boolean;
  addSpaceBetween?: boolean;
}

type Link = {
  text: string;
  url: string;
  noMarginTop?: boolean;
}

export type ColumnSection = {
  title?: string;
  subtitle?: string;
  links?: Link[];
  spaceBetween?: boolean;
}


const mapColumn = (columnList: ColumnSection[]) => {
  return columnList.map((p, idx) => {
    if(p.title){
      return <PublicFooterTitle key={idx}>{p.title}</PublicFooterTitle>
    }
    if(p.links){
      return (
        <React.Fragment key={idx}>
          {p.subtitle && <PublicFooterSubtitle>{p.subtitle}</PublicFooterSubtitle>}
          {p.links.map((link) => {
            return link.noMarginTop
              ? <PublicFooterLinkNoMarginTop
                  key={link.url}
                  href={link.url}
                  aria-label={link.text}>
                  {link.text}
                </PublicFooterLinkNoMarginTop>
              : <PublicFooterLink
                  key={link.url}
                  href={link.url}
                  aria-label={link.text}>
                  {link.text}
                </PublicFooterLink>
          })}
          {p.spaceBetween && <PublicFooterSpaceBetween/>}
        </React.Fragment>
      )
    }
  })
}

export const PublicFooter: React.FunctionComponent<Props> = ({
  company,
  disclaimers,
  healthIqSection,
  products,
  about,
  legal,
  phoneMapping
}: Props) => {

  const onClickCall = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const number = getPhoneNumber(phoneMapping);
    Pixels.callEvent()
    Analytics.log('Click To Call', {
      location: 'header', info: `tel:${ number }`
    });
    window.location.href = `tel:${ number }`;
  }

  return (
    <PublicFooterContainer>
      <PublicFooterRow>
        <PublicFooterEmptyColumn />
        <PublicFooterInfoColumn id="health-iq-section">
          {healthIqSection.map((x, idx: number) => {
            if(x.isTitle){
              return (
                <PublicFooterTitle key={idx}>
                  {x.text}
                </PublicFooterTitle>
              )
            }
            if(x.isPhoneNumber){
              return (
                <PhoneNumberWrapper
                  onClick={onClickCall}
                  key={idx}
                  aria-label="Click to Call"
                >
                  <PhoneNumber mapping={phoneMapping} format={'pretty'}/>
                </PhoneNumberWrapper>
              )
            }
            if(x.addSpaceBetween){
              return (
                <React.Fragment key={idx}>
                  <PublicFooterSpaceBetween />
                  <PublicFooterRegularText>{x.text}</PublicFooterRegularText>
                </React.Fragment>
              )
            }
            return (
              <PublicFooterRegularText key={idx}>
                {x.text}
              </PublicFooterRegularText>
            )
          })}
        </PublicFooterInfoColumn>
        <PublicFooterInfoColumn id="products">
          {mapColumn(products)}
        </PublicFooterInfoColumn>
        <PublicFooterInfoColumn id="about">
          {mapColumn(about)}
        </PublicFooterInfoColumn>
        <PublicFooterInfoColumn id="legal">
          {mapColumn(legal)}
        </PublicFooterInfoColumn>
        <PublicFooterEmptyColumnRight />
      </PublicFooterRow>
      <PublicFooterRow>
        <PublicFooterEmptyColumn />
        <PublicFooterCopyrightContainer>
          <PublicFooterCopyrightColumn>
            {company.map((text, idx) => {
              return idx === 0 ? (
                <PublicFooterSmallTextMarginBottom key={text}>{text}</PublicFooterSmallTextMarginBottom>
              ) : (
                <PublicFooterSmallText key={text}>{text}</PublicFooterSmallText>
              )
            })}
          </PublicFooterCopyrightColumn>
          <PublicFooterSmallLetterColumn>
            {disclaimers.map((text) => (
              <PublicFooterSmallTextMarginBottom dangerouslySetInnerHTML={{__html: text}} key={text} />
            ))}
          </PublicFooterSmallLetterColumn>
        </PublicFooterCopyrightContainer>
        <PublicFooterEmptyColumn />
      </PublicFooterRow>
    </PublicFooterContainer>
  )
}
